export default __webpack_public_path__ + "static/media/PolymerEquationImg.47185e9d.JPG";